import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
// Local Deps
import './CheckboxList.scss';

export default class CheckboxList extends Component {
  static propTypes = {
    header: PropTypes.string.isRequired,
    groupKey: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        text: PropTypes.string.isRequired,
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      }),
    ).isRequired,
    onItemClick: PropTypes.func.isRequired,
    selectedItems: PropTypes.array,
    parentIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    selectedPropertyName: PropTypes.string,
  };

  static defaultProps = {
    selectedItems: [],
    parentIndex: 1,
    selectedPropertyName: 'text',
  };

  static _generateListItems({
    parentIndex,
    items,
    onItemClick,
    groupKey,
    selectedItems,
    selectedPropertyName,
  }) {
    return items.map(item => {
      const selectedPropertyValue = get(item, selectedPropertyName);
      const isSelected = selectedItems.includes(selectedPropertyValue);
      return (
        <div
          className={`nf-checkbox-list__button nf-checkbox-list__item nf-button--transparent ${isSelected &&
            'nf-button--selected'}`}
          onClick={() => onItemClick(item, groupKey, parentIndex)}
          key={item.id}
        >
          <div className="pretty p-icon p-curve">
            <input
              type="checkbox"
              checked={isSelected}
              onChange={e => e.stopPropagation()}
            />
            <div className="state p-success">
              {/* <!-- ICON --> */}
              <i className="icon fa fa-check" />
              <label htmlFor="test">{item.text}</label>
            </div>
          </div>
        </div>
      );
    });
  }
  state = CheckboxList.initialState;

  render() {
    const { _generateListItems } = CheckboxList;

    const {
      items,
      header,
      onItemClick,
      groupKey,
      selectedItems,
      parentIndex,
      selectedPropertyName,
    } = this.props;

    return (
      <div className="nf-checkbox-list">
        {/* <!-- HEADER --> */}
        <h4 className="nf-checkbox-list__header">{header}</h4>
        {/* <!-- LIST --> */}
        {!isEmpty(items) &&
          _generateListItems({
            items,
            onItemClick,
            groupKey,
            selectedItems,
            parentIndex,
            selectedPropertyName,
          })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CheckboxList/CheckboxList.jsx